(() => {
  const selectors = {
    body: 'body',
    donateButton: '.donateButton',
    donationPopUp: '.donationPopUp',
    overflow: '.page-shade',
    closeButton: '.close-detail',
    radioButtons: '.donationPopUp [name="donation-product-variants"]',
    price: '.donationPopUp .current-price',
    addToCart: '.addToCart',
    activeVariant: '.donationPopUp input:checked',
    quantity: '.donationPopUp .quantity-wrapper input',

    bodyOverflow: 'body--overflow',
    popUpHidden: 'donationPopUp--hidden'
  };

  const donationButton = document.querySelector(selectors.donateButton);
  const overflow = document.querySelector(selectors.overflow);
  const closeButton = document.querySelector(selectors.closeButton);
  const radioButtons = document.querySelectorAll(selectors.radioButtons);
  const addToCartButton = document.querySelector(selectors.addToCart);

  function openModal(e) {
    e.preventDefault();
    const donationPopUp = document.querySelector(selectors.donationPopUp);
    const body = document.querySelector(selectors.body);

    body.classList.add(selectors.bodyOverflow);
    donationPopUp.classList.remove(selectors.popUpHidden);
  }

  function changeProductPrice(e) {
    const price = document.querySelector(selectors.price);

    price.innerHTML = theme.Shopify.formatMoney(e.currentTarget.dataset.price, theme.money_format);
  }

  function closeModal(e) {
    e.preventDefault();
    const donationPopUp = document.querySelector(selectors.donationPopUp);
    const body = document.querySelector(selectors.body);

    body.classList.remove(selectors.bodyOverflow);
    donationPopUp.classList.add(selectors.popUpHidden);
  }

  function addToCart(e) {
    e.preventDefault();
    const activeVariant = document.querySelector(selectors.activeVariant);
    const quantityInput = document.querySelector(selectors.quantity);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      body: JSON.stringify({ items: [{id: activeVariant.value, quantity: quantityInput.value}] }),
      headers: {
        "Content-Type": "application/json"
      }
    }).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      closeModal(e);
      document.dispatchEvent(
      new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
    });
  }

  donationButton?.addEventListener("click", openModal);
  overflow?.addEventListener("click", closeModal);
  closeButton?.addEventListener("click", closeModal);
  addToCartButton?.addEventListener("click", addToCart);

  radioButtons.forEach(button => {
    button.addEventListener("change", changeProductPrice);
  })
})();